
$(document).ready(function () {



   // Lazy Load the poster

    const $videos = $(".vid_blk video");

  const videoObserver = new IntersectionObserver((entries, obs) => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) return;

      const $video = $(entry.target);
      $video.attr({
        preload: "auto",
        muted: true,
        playsinline: true
      });

      // A real, merchant-uploaded thumbnail is instant and reliable --
      // only fall back to the silent-autoplay-and-snapshot trick for
      // videos that don't have one, since that approach depends on
      // network speed and can leave a video blank on a slow connection.
      if (!entry.target.getAttribute("poster")) {
        generatePosterAfter5Sec($video);
      }

      obs.unobserve(entry.target);
    });
  }, { rootMargin: "100px" });

  $videos.each(function () {
    videoObserver.observe(this);
  });

  function generatePosterAfter5Sec($video) {
    const video = $video.get(0);
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext("2d");
    let captured = false;

    $video.attr("crossorigin", "anonymous");

    // Try autoplay silently to ensure timeupdate fires
    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch(err => console.warn("Autoplay blocked:", err));
    }

    function capturePoster() {
      if (captured || !video.videoWidth) return false;
      try {
        canvas.width = video.videoWidth;
        canvas.height = video.videoHeight;
        ctx.drawImage(video, 0, 0, canvas.width, canvas.height);
        $video.attr("poster", canvas.toDataURL("image/jpeg"));
        captured = true;
        return true;
      } catch (err) {
        console.warn("⚠️ Unable to capture frame — likely CORS issue:", err);
        return false;
      }
    }

    function stop() {
      $video.off("timeupdate", onTimeUpdate);
      $video.off("pause", onPause);
    }

    function onTimeUpdate() {
      if (video.currentTime >= 1) {
        const justCaptured = capturePoster();
        stop();
        // Only pause if THIS call captured it -- never pause a video the
        // viewer may already be genuinely watching by now.
        if (justCaptured) video.pause();
      }
    }

    function onPause() {
      if (capturePoster()) stop();
    }

    $video.on("timeupdate", onTimeUpdate);
    $video.on("pause", onPause);

    // Exposed so real user-initiated playback can permanently cancel this
    // background process -- otherwise its stale timeupdate listener can
    // fire mid-watch and pause the video out from under the viewer.
    $video.data("cancelPosterCapture", stop);
  }


  // Video auto play and hover effect

  // Only bind hover-preview behavior for real mouse/trackpad input. On
  // touch devices, a bound mouseenter handler makes browsers treat the
  // first tap as hover-simulation and require a second tap to register
  // as a real click, which is why tapping used to need multiple presses.
  const supportsHover = window.matchMedia &&
    window.matchMedia("(hover: hover) and (pointer: fine)").matches;

  if (supportsHover) {
    $(document).on("mouseenter", ".vid_blk", function () {
      $(".vid_blk video").trigger("pause");
      $(".vid_blk .video_cta").fadeIn();

      $(this).find(".video_cta").fadeOut();
      $(this).find("video").prop("muted", true).trigger("play");
    });

    $(document).on("mouseleave", ".vid_blk", function () {
      const vid = $(this).find("video").get(0);
      if (vid) {
        vid.pause();
        // Don't seek back to 0: forcing a rewind on a video that hasn't
        // finished loading/decoding its poster frame yet shows solid
        // black instead of a thumbnail. Just stop playback in place.
        $(vid).removeAttr("controls").prop("muted", true);
      }
      $(this).find(".video_cta").fadeIn();
    });
  }

  // .video_cta is a child of .vid_blk, so a real click on it already
  // bubbles up and fires this handler directly — no separate handler or
  // synthetic re-trigger needed. Calling video.play() straight from this
  // directly-bound click handler (instead of through a re-triggered
  // synthetic event) keeps it reliably inside the browser's user-gesture
  // window, so unmuted playback isn't silently blocked.
  $(document).on("click", ".vid_blk", function (e) {
    e.stopPropagation();
    const $block = $(this);
    const clickedVideo = $block.find("video").get(0);
    if (!clickedVideo) return;

    // Videos autoplay silently (muted) in the background to snapshot a
    // poster frame. That counts as "not paused" but isn't real user
    // playback -- only an unmuted, actively-playing video should toggle
    // to pause on tap; otherwise the first real tap on a video still
    // mid-snapshot would immediately pause it instead of starting it.
    const isPlaying = !clickedVideo.paused && !clickedVideo.ended && !clickedVideo.muted;

    if (isPlaying) {
      // Pause in place (no seek) so tapping again resumes from where the
      // viewer left off instead of restarting from the beginning.
      clickedVideo.pause();
      $(clickedVideo).removeAttr("controls").prop("muted", true);
      $block.find(".video_cta").fadeIn();
      return;
    }

    $(".vid_blk video").each(function () {
      if (this !== clickedVideo) {
        // Pause only — don't seek. Forcing currentTime back to 0 on a
        // video whose background poster-capture hasn't finished yet
        // interrupts it and leaves that block permanently black.
        this.pause();
        $(this).removeAttr("controls").prop("muted", true);
      }
    });
    $(".vid_blk .video_cta").fadeIn();

    // Cancel the background poster-snapshot process for good, so its
    // timeupdate listener can never fire and pause real playback mid-watch.
    const cancelPosterCapture = $block.find("video").data("cancelPosterCapture");
    if (cancelPosterCapture) cancelPosterCapture();

    clickedVideo.muted = false;
    clickedVideo.setAttribute("controls", "controls");

    const playPromise = clickedVideo.play();
    if (playPromise !== undefined) {
      playPromise
        .then(function () {
          $block.find(".video_cta").fadeOut();
        })
        .catch(function (err) {
          console.warn("Video play blocked:", err);
          // Leave the play button visible so the user can tap again.
        });
    } else {
      $block.find(".video_cta").fadeOut();
    }
  });

  $('.slick-quick-user-slider').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 600,
    pauseOnHover: true,
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2.4,
          slidesToScroll: 1,
        }
      }
    ]
  });

  $(".slick-custom-testimonial").slick({
      dots: false,
      arrows: true,
      infinite: true,
      autoplay: false,
      speed: 600,
      autoplaySpeed: 4000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        {
        breakpoint: 991,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        }
      }
    ]
  });
});


// Prodcut Page Result circular Progress 

document.addEventListener("DOMContentLoaded", () => {
  const progressBars = document.querySelectorAll(".progress-wrap");

  const animateProgress = (el) => {
    const circle = el.querySelector(".progress");
    const percent = el.getAttribute("data-percent");

    const radius = 30;
    const circumference = 2 * Math.PI * radius;

    const offset = circumference - (percent / 100) * circumference;

    circle.style.strokeDasharray = circumference;
    circle.style.strokeDashoffset = circumference;

    setTimeout(() => {
      circle.style.strokeDashoffset = offset;
    }, 200);
  };

  // 🔥 Run on page load (for visible elements)
  progressBars.forEach(el => {
    const rect = el.getBoundingClientRect();
    if (rect.top < window.innerHeight) {
      animateProgress(el);
      el.classList.add("animated");
    }
  });

  // 🔥 Run on scroll (viewport trigger)
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !entry.target.classList.contains("animated")) {
        animateProgress(entry.target);
        entry.target.classList.add("animated");
      }
    });
  }, { threshold: 0.5 });

  progressBars.forEach(el => observer.observe(el));
});

document.addEventListener('DOMContentLoaded', function () {

  const promoBar = document.getElementById('promo-bar');

  const hoursEl = document.getElementById('promo-hours');
  const minutesEl = document.getElementById('promo-minutes');
  const secondsEl = document.getElementById('promo-seconds');

  if (
    !promoBar ||
    !hoursEl ||
    !minutesEl ||
    !secondsEl
  ) {
    return;
  }

  /*
   * SHOW BAR ON SCROLL
   */
  window.addEventListener('scroll', function () {

    if (window.scrollY > 600) {
      promoBar.classList.add('show');
    } else {
      promoBar.classList.remove('show');
    }

  });

  /*
   * TIMER
   * Resets every midnight
   */

  function getSecondsUntilMidnight() {

    const now = new Date();

    const midnight = new Date();

    midnight.setHours(24, 0, 0, 0);

    return Math.floor(
      (midnight.getTime() - now.getTime()) / 1000
    );
  }

  let remainingSeconds = getSecondsUntilMidnight();

  function updateTimer() {

    const hours = Math.floor(
      remainingSeconds / 3600
    );

    const minutes = Math.floor(
      (remainingSeconds % 3600) / 60
    );

    const seconds = remainingSeconds % 60;

    hoursEl.textContent =
      String(hours).padStart(2, '0');

    minutesEl.textContent =
      String(minutes).padStart(2, '0');

    secondsEl.textContent =
      String(seconds).padStart(2, '0');

    if (remainingSeconds <= 0) {
      remainingSeconds = getSecondsUntilMidnight();
    } else {
      remainingSeconds--;
    }

  }

  updateTimer();

  setInterval(updateTimer, 1000);

});